import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { DownloadProps } from '@urc-ui/components/icons/download-icon/types';
import { Icon, Link, Text, Tooltip } from '@amzn/storm-ui-v3';
import { isSpoofer, canSpooferDownloadReport } from '@urc-ui/utils/app-utils';

const StyledText = styled(Text)`
  text-align: center;
`;

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.black};
`;

const StyledDisabledIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.gray[400]};
`;

const DownloadIcon = (props: DownloadProps) => {
  const { t: translate } = useTranslation();
  const noPermissionText = translate(
    'sspa_rcm_ad_reports_download_no_permission_tooltip',
    'Only users with Admin, Editor, or Download roles can download this report.'
  );
  const downloadDisabled = isSpoofer() && !canSpooferDownloadReport();

  if (!props.url) {
    return <StyledText>&#8212;</StyledText>;
  }

  if (downloadDisabled) {
    return (
      <StyledDiv>
        <Tooltip trigger={<StyledDisabledIcon type='download' aria-disabled='true' />} message={noPermissionText} />
      </StyledDiv>
    );
  }

  return (
    <StyledDiv>
      <Link href={props.url} onClick={props.onClick}>
        <StyledIcon type='download'></StyledIcon>
      </Link>
    </StyledDiv>
  );
};

export { DownloadIcon };
